import React, { useContext, useEffect, useState } from "react"
import { Card, Transition } from "semantic-ui-react"
import { Moment } from "moment"
import { CampingStyleProps, CampProps, SiteProps } from "../../interfaces"
import Features from "./Features"
import Payment from "./Payment"
import { validElectric, validRigType } from "../../types"
import { BookerContext } from "../../contexts/BookerContext"
import Button from "../ui/Button"
import { formatMoneyFromCents } from "../../utils/formatMoney"
import classNames from "../../utils/classNames"
import BookerButton from "../ui/BookerButton"

interface ComponentProps {
  visible: boolean
  camp: CampProps
  site: SiteProps
  startDate: Moment
  endDate: Moment
  setIsPaying: any
  userCampingStyle: CampingStyleProps
  userRigType: validRigType
  userRigLength: number
  userElectric: validElectric
  userPassengers: number
  userKidCampers: number
  onError: (errorMessage: string) => void
  skipShowFeatures: boolean
  showPayment: boolean
  setShowPayment: any
}

const SelectionCard = (props: ComponentProps) => {
  useEffect(() => {
    if (
      props.skipShowFeatures ||
      (!props.userCampingStyle?.is_showing_features && !props.site?.notes && props.visible)
    ) {
      props.setShowPayment(true)
      return
    }
  }, [props.visible])

  if (!(props.site && props.startDate && props.endDate)) {
    return <></>
  }

  return (
    <Card fluid className={props.visible ? "transition visible active" : "transition hidden"}>
      <Card.Content>
        <Transition.Group animation="fade right">
          <Payment
            visible={props.showPayment}
            camp={props.camp}
            camping_style={props.userCampingStyle}
            site={props.site}
            startDate={props.startDate}
            endDate={props.endDate}
            setIsPaying={props.setIsPaying}
            userRigType={props.userRigType}
            userRigLength={props.userRigLength}
            userElectric={props.userElectric}
            userPassengers={props.userPassengers}
            userKidCampers={props.userKidCampers}
            onError={props.onError}
          />
        </Transition.Group>
      </Card.Content>
    </Card>
  )
}

export default SelectionCard
